import { render, staticRenderFns } from "./PromotionsModal.vue?vue&type=template&id=affff9cc&scoped=true"
import script from "./PromotionsModal.vue?vue&type=script&lang=js"
export * from "./PromotionsModal.vue?vue&type=script&lang=js"
import style0 from "./PromotionsModal.vue?vue&type=style&index=0&id=affff9cc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "affff9cc",
  null
  
)

export default component.exports